/* global femcare */

/**
 * Google Analytics 4 events.
 */
femcare.tracking.forms = {
    /**
     * Initialize the form tracking module.
     */
    init: function () {
        this.formVisible();
        this.observeModalForms();

        // Use debounce to call formVisible 200ms after the user stops scrolling
        var timeout;
        $(window).on('wheel scroll resize touchstart touchmove', () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                this.formVisible();
            }, 200);
        });

        $(document).on('input', 'form input', (event) => {
            var $input = $(event.target);
            var $form = $input.closest('form');
            var formType = $form.data('ga-is-sample');
            var isRRForm = $form.parents('.power-reviews,.show-reviews-container').length;
            var isBVForm = $form.hasClass('bv-form');
            let isSearchForm = $form.hasClass('search-form');

            if (!isRRForm && !isBVForm && !isSearchForm) {
                this.formStarted(event, formType);
            }
        });

        $(document).on('submit', 'form', (event) => {
            var $form = $(event.target).closest('form');
            var formType = $form.data('ga-is-sample');
            var isRRForm = $form.parents('.power-reviews,.show-reviews-container').length;
            var isBVForm = $form.hasClass('bv-form');
            let isSearchForm = $form.hasClass('search-form');

            if (!isRRForm && !isBVForm && !isSearchForm) {
                this.formSubmit(formType, $form);
            }
        });
    },

    /**
     * Checks each form on the page for visibility and adds analytics tracking if visible.
     */
    formVisible: function () {
        $('form').each((index, element) => {
            let $element = $(element);
            let formVisible = femcare.shared.util.isAnyPartOfElementInViewport($element);

            let isRRForm = $element.parents('.power-reviews,.show-reviews-container').length;
            let isBVForm = $element.hasClass('bv-form');
            let isSearchForm = $element.hasClass('search-form');
            let isSampleForm = $element.data('ga-is-sample');

            if (formVisible && !isRRForm && !isBVForm && !isSearchForm && !isSampleForm) {
                this.addVisibleFormAnalytics($element);
            }
        });
    },

    /**
     * Adds analytics data when a form becomes visible.
     * @param {jQuery} $form - The jQuery object representing the form element.
     */
    addVisibleFormAnalytics: function ($form) {
        var formName = $form.data('ga-form-name');
        var formId = $form.data('ga-form-id');

        if (!$form.data('ga4_form_visible')) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'ga4_form_visible',
                ga4_data: {
                    form_name: formName,
                    form_id: formId,
                }
            });

            // Set a flag to indicate that the event has been triggered for this form.
            $form.data('ga4_form_visible', true);
        }
    },

    /**
     * Track the event when a user starts filling out a field in a form.
     * The event is triggered for any form on the page when a user starts
     * filling out a field with the first letter.
     */
    formStarted: function (event, isSample) {
        var $input = $(event.target);
        var $form = $input.closest('form');

        // Check if the event has already been triggered for this input field.
        if (!$form.data('ga4_form_started')) {
            var formName = $form.data('ga-form-name');
            var formId = $form.data('ga-form-id');

            window.dataLayer = window.dataLayer || [];

            if (!isSample) {
                window.dataLayer.push({
                    event: 'ga4_form_start',
                    ga4_data: {
                        form_name: formName, // Dynamically collected form name.
                        form_id: formId,     // Dynamically pushed HTML id attribute of the form element.
                    }
                });
            } else if (isSample) {
                window.dataLayer.push({
                    event: 'ga4_sample_form',
                    ga4_data: {
                        action_type: 'Filling out the form',
                        step_name: 'Filling out the form',
                        step_number: 2,
                        single_item_id: formId,
                        single_item_name: formName 
                    }
                });
            }

            // Set a flag to indicate that the event has been triggered for this input field.
            $form.data('ga4_form_started', true);
        }
    },

    /**
     * Track form submissions for both existing and dynamically added forms.
     */
    formSubmit: function (isSample, $form) {
        var formName = $form.data('ga-form-name');
        var formId = $form.data('ga-form-id');

        window.dataLayer = window.dataLayer || [];
        if (!isSample) {
            window.dataLayer.push({
                event: 'ga4_form_submit',
                ga4_data: {
                    form_name: formName,
                    form_id: formId,
                }
            });
        } else if (isSample) {
            window.dataLayer.push({
                event: 'ga4_sample_form',
                ga4_data: {
                    action_type: 'Confirmation',
                    step_name: 'Confirmation',
                    step_number: 3,
                    single_item_id: formId,
                    single_item_name: formName
                }
            });
        }

        // Trigger old GA event
        femcare.tracking.gaTracking.formSubmit($form);
    },

    /**
     * Add analytics when sample form becomes visible.
     */
    sampleFormVisible: function (form) {
        var $form = $(form);
        var sampleId = $form.data('ga-form-id');
        var sampleName = $form.data('ga-form-name');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'ga4_sample_form',
            ga4_data: {
                action_type: 'Initiate request form',
                step_name: 'Initiate request form',
                step_number: 1,
                single_item_id: sampleId,
                single_item_name: sampleName,
            }
        });
    },

    /**
     * Observes modals for when they become visible and triggers form analytics.
     * Uses MutationObserver to detect when the 'displayed' class is added to modals.
     */
    observeModalForms: function () {
        let self = this;
        let modals = document.querySelectorAll('.modal');

        modals.forEach(function (modal) {
            let observer = new MutationObserver(function (mutations) {
                let hasClassChange = mutations.some(function (mutation) {
                    return mutation.attributeName === 'class';
                });

                if (hasClassChange && modal.classList.contains('displayed')) {
                    self.checkModalForms(modal);
                }
            });

            observer.observe(modal, { attributes: true });
        });
    },

    /**
     * Checks for forms inside a modal and triggers visibility analytics.
     * @param {HTMLElement} modal - The modal element that became visible.
     */
    checkModalForms: function (modal) {
        let self = this;
        let $forms = $(modal).find('form');

        $forms.each(function (index, element) {
            let $element = $(element);
            let isRRForm = $element.parents('.power-reviews,.show-reviews-container').length;
            let isBVForm = $element.hasClass('bv-form');
            let isSearchForm = $element.hasClass('search-form');
            let isSampleForm = $element.data('ga-is-sample');

            if (!isRRForm && !isBVForm && !isSearchForm && !isSampleForm) {
                self.addVisibleFormAnalytics($element);
            }
        });
    }
};
